<template>
    <div v-if="isOpen" class="modal-overlay">
        <div class="modal">
            <h3 class="text-xl font-semibold mb-4">{{ $translate('Did you forget something?') }}</h3>
            <p class="text-gray-600 mb-4">
                {{ $translate('If you want, you can add the following extras to this event.') }}
            </p>
            <div class="grid grid-cols-2 gap-4 mb-4">
                <div v-for="addon in addons" :key="addon.id"
                    :class="['addon-card', selectedAddon === addon.id ? 'selected' : '']"
                    @click="selectAddon(addon.id)">
                    <img :src="addon.image.large" alt="" class="addon-image">
                    <div class="addon-info">
                        <h4 class="font-medium text-lg">{{ addon.name }}</h4>
                        <p class="text-gray-600">{{ addon.price.formatted }} <small v-if="addon.unit"> / {{ addon.unit
                                }}</small></p>
                        <p class="text-gray-500">{{ addon.excerpt }}</p>
                    </div>
                </div>
            </div>
            <div class="flex justify-end">
                <button type="button" @click="closeModal"
                    class="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400">
                    {{ $translate('Close') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import { cookie } from '@/utils/cookie';

export default {
    name: 'AddonModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        itemId: {
            type: String,
            required: false
        }
    },
    setup(props, { emit }) {
        const addons = ref([]);
        const selectedAddon = ref('');

        const fetchAddons = async () => {
            try {
                const response = await fetch(
                    `${window.vueAppConfig.endpoint}/api/v2/events/cart/list`,
                    {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            brand_id: window.vueAppConfig.info.id,
                            session_id: cookie(),
                            item_id: props.itemId
                        })
                    }
                );

                const data = await response.json();
                if (data.status) {
                    addons.value = data.products;
                }
            } catch (error) {
                console.error('Error fetching add-ons:', error);
            }
        };

        const selectAddon = (addonId) => {
            selectedAddon.value = addonId;
            const selectedProduct = addons.value.find(addon => addon.id === addonId);
            if (selectedProduct) {
                emit('submit', selectedProduct.id);
            }
        };

        const closeModal = () => {
            emit('close');
        };

        watch(props, (newProps) => {
            if (newProps.isOpen) {
                fetchAddons();
                selectedAddon.value = '';
            }
        });

        return {
            addons,
            selectedAddon,
            selectAddon,
            closeModal
        };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 36rem;
    width: 100%;
}

.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
}

.addon-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.3s;
}

.addon-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.addon-card.selected {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px #3b82f6;
}

.addon-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
}

.addon-info {
    padding: 0.5rem;
}

.addon-info h4 {
    margin-bottom: 0.25rem;
}
</style>
